import { render, staticRenderFns } from "./LandEstates.vue?vue&type=template&id=5bbda93c&scoped=true&"
import script from "./LandEstates.vue?vue&type=script&lang=ts&"
export * from "./LandEstates.vue?vue&type=script&lang=ts&"
import style0 from "./LandEstates.vue?vue&type=style&index=0&id=5bbda93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbda93c",
  null
  
)

export default component.exports